import Icon from 'components/Icon'
import { IconButton } from 'components/IconButton'
import { observer } from 'mobx-react'
import React from 'react'
import { ScopeChangeCustomItem } from '../../RequestScopeChangesViewModel'
import cx from 'classnames'
import styles from './ScopeChangeCustomItem.sass'

export default observer(function ScopeChangeCustomItem({
  item,
  dataTestId,
  remove,
  updateQuantity,
}: {
  item: ScopeChangeCustomItem
  dataTestId: number
  remove: (key: string) => void
  updateQuantity?: boolean
}) {
  if (updateQuantity) {
    return (
      <ScopeChangeCustomItemUpdateQuantity
        item={item}
        remove={remove}
        dataTestId={dataTestId}
      />
    )
  }

  return (
    <ScopeChangeCustomItemSelection
      item={item}
      remove={remove}
      dataTestId={dataTestId}
    />
  )
})

const ScopeChangeCustomItemUpdateQuantity = observer(
  function ScopeChangeCustomItemUpdateQuantity({
    item,
    remove,
    dataTestId,
  }: {
    item: ScopeChangeCustomItem
    remove: (key: string) => void
    dataTestId: number
  }) {
    return (
      <div className={styles.customItemInput}>
        <IconButton
          className={styles.removeCustomItemButton}
          onClick={() => remove(item.key)}
          dataTest={`request-scope-changes-remove-button-${dataTestId}`}
        >
          <Icon name="close" size={24} />
        </IconButton>

        <div className={styles.textContainer}>
          <div className={styles.title}>{item.name}</div>
        </div>

        {/* This should always be 0 as it's a custom item. */}
        <div className={styles.currentQuantityContainer}>0</div>

        <div
          className={cx(
            styles.customItemQuantityContainer,
            item.validation.getError('quantity') && styles.hasError,
          )}
        >
          <IconButton onClick={item.decrementQuantity}>
            <Icon name="subtract" size={16} />
          </IconButton>

          <input
            key="quantity"
            type="number"
            min="1"
            className={cx(styles.input, styles.customItemQuantity)}
            value={item.quantity}
            onChange={(e) => item.setQuantity(e.target.value)}
            data-test={`scope-change-quantity-${dataTestId}`}
          />

          <IconButton onClick={item.incrementQuantity}>
            <Icon name="add" size={16} />
          </IconButton>
        </div>
      </div>
    )
  },
)

const ScopeChangeCustomItemSelection = observer(
  function ScopeChangeCustomItemSelection({
    item,
    remove,
    dataTestId,
  }: {
    item: ScopeChangeCustomItem
    remove: (key: string) => void
    dataTestId: number
  }) {
    return (
      <div className={styles.customItemInput}>
        <IconButton
          className={styles.removeCustomItemButton}
          onClick={() => remove(item.key)}
          dataTest={`request-scope-changes-remove-button-${dataTestId}`}
        >
          <Icon name="close" size={24} />
        </IconButton>

        <input
          type="text"
          className={cx(
            styles.input,
            styles.customItemName,
            item.validation.getError('name') && styles.hasError,
          )}
          placeholder="Enter your service type"
          value={item.name}
          onChange={(e) => item.setName(e.target.value)}
          data-test={`scope-change-name-${dataTestId}`}
        />
      </div>
    )
  },
)
